export default __webpack_public_path__ + "static/media/homeseller-home.d32f6da9.jpg";